import { Extension } from '@tiptap/core';

declare module '@tiptap/core' {
   interface Commands<ReturnType> {
      submitError: {
         showError: (arg0: string) => ReturnType;
         clearError: () => ReturnType;
      };
   }
   interface Storage {
      submitError: { error: string | null };
   }
}

export const SubmitError = Extension.create({
   name: 'submitError',

   addStorage() {
      return {
         error: null,
      };
   },
   addCommands() {
      return {
         showError:
            (error: string) =>
            ({ dispatch }) => {
               if (dispatch) {
                  this.storage.error = error;
               }

               return true;
            },
         clearError:
            () =>
            ({ dispatch }) => {
               if (dispatch) {
                  this.storage.error = null;
               }

               return true;
            },
      };
   },
});
